import {fromJS} from "immutable";

const ALL_COUNTRIES = fromJS([
  {name: "Afghanistan", code: "AF"}, 
  {name: "Åland Islands", code: "AX"}, 
  {name: "Albania", code: "AL", continent: "Europe"}, 
  {name: "Algeria", code: "DZ"}, 
  {name: "American Samoa", code: "AS"}, 
  {name: "Andorra", code: "AD", continent: "Europe"}, 
  {name: "Angola", code: "AO"}, 
  {name: "Anguilla", code: "AI"}, 
  {name: "Antarctica", code: "AQ"}, 
  {name: "Antigua and Barbuda", code: "AG"}, 
  {name: "Argentina", code: "AR"}, 
  {name: "Armenia", code: "AM", continent: "Europe"}, 
  {name: "Aruba", code: "AW"}, 
  {name: "Australia", code: "AU"}, 
  {name: "Austria", code: "AT", continent: "Europe", shipping: "free", taxIncluded: true}, 
  {name: "Azerbaijan", code: "AZ", continent: "Europe"}, 
  {name: "Bahamas", code: "BS"}, 
  {name: "Bahrain", code: "BH"}, 
  {name: "Bangladesh", code: "BD"}, 
  {name: "Barbados", code: "BB"}, 
  {name: "Belarus", code: "BY", continent: "Europe"}, 
  {name: "Belgium", code: "BE", continent: "Europe"}, 
  {name: "Belize", code: "BZ"}, 
  {name: "Benin", code: "BJ"}, 
  {name: "Bermuda", code: "BM"}, 
  {name: "Bhutan", code: "BT"}, 
  {name: "Bolivia", code: "BO"}, 
  {name: "Bosnia and Herzegovina", code: "BA", continent: "Europe"}, 
  {name: "Botswana", code: "BW"}, 
  {name: "Bouvet Island", code: "BV"}, 
  {name: "Brazil", code: "BR"}, 
  {name: "British Indian Ocean Territory", code: "IO"}, 
  {name: "Brunei Darussalam", code: "BN"}, 
  {name: "Bulgaria", code: "BG", continent: "Europe"}, 
  {name: "Burkina Faso", code: "BF"}, 
  {name: "Burundi", code: "BI"}, 
  {name: "Cambodia", code: "KH"}, 
  {name: "Cameroon", code: "CM"}, 
  {name: "Canada", code: "CA"}, 
  {name: "Cape Verde", code: "CV"}, 
  {name: "Cayman Islands", code: "KY"}, 
  {name: "Central African Republic", code: "CF"}, 
  {name: "Chad", code: "TD"}, 
  {name: "Chile", code: "CL"}, 
  {name: "China", code: "CN"}, 
  {name: "Christmas Island", code: "CX"}, 
  {name: "Cocos (Keeling) Islands", code: "CC"}, 
  {name: "Colombia", code: "CO"}, 
  {name: "Comoros", code: "KM"}, 
  {name: "Congo", code: "CG"}, 
  {name: "Congo, The Democratic Republic of the", code: "CD"}, 
  {name: "Cook Islands", code: "CK"}, 
  {name: "Costa Rica", code: "CR"}, 
  {name: "Cote D\"Ivoire", code: "CI"}, 
  {name: "Croatia", code: "HR", continent: "Europe"}, 
  {name: "Cuba", code: "CU"}, 
  {name: "Cyprus", code: "CY", continent: "Europe"}, 
  {name: "Czech Republic", code: "CZ", continent: "Europe"}, 
  {name: "Denmark", code: "DK", continent: "Europe"}, 
  {name: "Djibouti", code: "DJ"}, 
  {name: "Dominica", code: "DM"}, 
  {name: "Dominican Republic", code: "DO"}, 
  {name: "Ecuador", code: "EC"}, 
  {name: "Egypt", code: "EG"}, 
  {name: "El Salvador", code: "SV"}, 
  {name: "Equatorial Guinea", code: "GQ"}, 
  {name: "Eritrea", code: "ER"}, 
  {name: "Estonia", code: "EE", continent: "Europe"}, 
  {name: "Ethiopia", code: "ET"}, 
  {name: "Falkland Islands (Malvinas)", code: "FK"}, 
  {name: "Faroe Islands", code: "FO"}, 
  {name: "Fiji", code: "FJ"}, 
  {name: "Finland", code: "FI", continent: "Europe"}, 
  {name: "France", code: "FR", continent: "Europe"}, 
  {name: "French Guiana", code: "GF"}, 
  {name: "French Polynesia", code: "PF"}, 
  {name: "French Southern Territories", code: "TF"}, 
  {name: "Gabon", code: "GA"}, 
  {name: "Gambia", code: "GM"}, 
  {name: "Georgia", code: "GE", continent: "Europe"}, 
  {name: "Germany", code: "DE", continent: "Europe", shipping: "free"}, 
  {name: "Ghana", code: "GH"}, 
  {name: "Gibraltar", code: "GI"}, 
  {name: "Greece", code: "GR", continent: "Europe"}, 
  {name: "Greenland", code: "GL"}, 
  {name: "Grenada", code: "GD"}, 
  {name: "Guadeloupe", code: "GP"}, 
  {name: "Guam", code: "GU"}, 
  {name: "Guatemala", code: "GT"}, 
  {name: "Guernsey", code: "GG"}, 
  {name: "Guinea", code: "GN"}, 
  {name: "Guinea-Bissau", code: "GW"}, 
  {name: "Guyana", code: "GY"}, 
  {name: "Haiti", code: "HT"}, 
  {name: "Heard Island and Mcdonald Islands", code: "HM"}, 
  {name: "Holy See (Vatican City State)", code: "VA", continent: "Europe"}, 
  {name: "Honduras", code: "HN"}, 
  {name: "Hong Kong", code: "HK"}, 
  {name: "Hungary", code: "HU", continent: "Europe"}, 
  {name: "Iceland", code: "IS", continent: "Europe"}, 
  {name: "India", code: "IN"}, 
  {name: "Indonesia", code: "ID"}, 
  {name: "Iran, Islamic Republic Of", code: "IR"}, 
  {name: "Iraq", code: "IQ"}, 
  {name: "Ireland", code: "IE", continent: "Europe"}, 
  {name: "Isle of Man", code: "IM"}, 
  {name: "Israel", code: "IL"}, 
  {name: "Italy", code: "IT", continent: "Europe"}, 
  {name: "Jamaica", code: "JM"}, 
  {name: "Japan", code: "JP"}, 
  {name: "Jersey", code: "JE"}, 
  {name: "Jordan", code: "JO"}, 
  {name: "Kazakhstan", code: "KZ", continent: "Europe"}, 
  {name: "Kenya", code: "KE"}, 
  {name: "Kiribati", code: "KI"}, 
  {name: "Korea, Democratic People\"s Republic of", code: "KP"}, 
  {name: "Korea, Republic of", code: "KR"}, 
  {name: "Kuwait", code: "KW"}, 
  {name: "Kyrgyzstan", code: "KG"}, 
  {name: "Lao People\"s Democratic Republic", code: "LA"}, 
  {name: "Latvia", code: "LV", continent: "Europe"}, 
  {name: "Lebanon", code: "LB"}, 
  {name: "Lesotho", code: "LS"}, 
  {name: "Liberia", code: "LR"}, 
  {name: "Libyan Arab Jamahiriya", code: "LY"}, 
  {name: "Liechtenstein", code: "LI", continent: "Europe"}, 
  {name: "Lithuania", code: "LT", continent: "Europe"}, 
  {name: "Luxembourg", code: "LU", continent: "Europe"}, 
  {name: "Macao", code: "MO"}, 
  {name: "Macedonia, The Former Yugoslav Republic of", code: "MK", continent: "Europe"}, 
  {name: "Madagascar", code: "MG"}, 
  {name: "Malawi", code: "MW"}, 
  {name: "Malaysia", code: "MY"}, 
  {name: "Maldives", code: "MV"}, 
  {name: "Mali", code: "ML"}, 
  {name: "Malta", code: "MT", continent: "Europe"}, 
  {name: "Marshall Islands", code: "MH"}, 
  {name: "Martinique", code: "MQ"}, 
  {name: "Mauritania", code: "MR"}, 
  {name: "Mauritius", code: "MU"}, 
  {name: "Mayotte", code: "YT"}, 
  {name: "Mexico", code: "MX"}, 
  {name: "Micronesia, Federated States of", code: "FM"}, 
  {name: "Moldova, Republic of", code: "MD", continent: "Europe"}, 
  {name: "Monaco", code: "MC", continent: "Europe"}, 
  {name: "Mongolia", code: "MN"}, 
  {name: "Montenegro", code: "ME", continent: "Europe"}, 
  {name: "Montserrat", code: "MS"}, 
  {name: "Morocco", code: "MA"}, 
  {name: "Mozambique", code: "MZ"}, 
  {name: "Myanmar", code: "MM"}, 
  {name: "Namibia", code: "NA"}, 
  {name: "Nauru", code: "NR"}, 
  {name: "Nepal", code: "NP"}, 
  {name: "Netherlands", code: "NL", continent: "Europe"}, 
  {name: "Netherlands Antilles", code: "AN"}, 
  {name: "New Caledonia", code: "NC"}, 
  {name: "New Zealand", code: "NZ"}, 
  {name: "Nicaragua", code: "NI"}, 
  {name: "Niger", code: "NE"}, 
  {name: "Nigeria", code: "NG"}, 
  {name: "Niue", code: "NU"}, 
  {name: "Norfolk Island", code: "NF"}, 
  {name: "Northern Mariana Islands", code: "MP"}, 
  {name: "Norway", code: "NO", continent: "Europe"}, 
  {name: "Oman", code: "OM"}, 
  {name: "Pakistan", code: "PK"}, 
  {name: "Palau", code: "PW"}, 
  {name: "Palestinian Territory, Occupied", code: "PS"}, 
  {name: "Panama", code: "PA"}, 
  {name: "Papua New Guinea", code: "PG"}, 
  {name: "Paraguay", code: "PY"}, 
  {name: "Peru", code: "PE"}, 
  {name: "Philippines", code: "PH"}, 
  {name: "Pitcairn", code: "PN"}, 
  {name: "Poland", code: "PL", continent: "Europe"}, 
  {name: "Portugal", code: "PT", continent: "Europe"}, 
  {name: "Puerto Rico", code: "PR"}, 
  {name: "Qatar", code: "QA"}, 
  {name: "Reunion", code: "RE"}, 
  {name: "Romania", code: "RO", continent: "Europe"}, 
  {name: "Russian Federation", code: "RU"}, 
  {name: "Rwanda", code: "RW"}, 
  {name: "Saint Helena", code: "SH"}, 
  {name: "Saint Kitts and Nevis", code: "KN"}, 
  {name: "Saint Lucia", code: "LC"}, 
  {name: "Saint Pierre and Miquelon", code: "PM"}, 
  {name: "Saint Vincent and the Grenadines", code: "VC"}, 
  {name: "Samoa", code: "WS"}, 
  {name: "San Marino", code: "SM", continent: "Europe"}, 
  {name: "Sao Tome and Principe", code: "ST"}, 
  {name: "Saudi Arabia", code: "SA"}, 
  {name: "Senegal", code: "SN"}, 
  {name: "Serbia", code: "RS", continent: "Europe"}, 
  {name: "Seychelles", code: "SC"}, 
  {name: "Sierra Leone", code: "SL"}, 
  {name: "Singapore", code: "SG"}, 
  {name: "Slovakia", code: "SK", continent: "Europe"}, 
  {name: "Slovenia", code: "SI", continent: "Europe"}, 
  {name: "Solomon Islands", code: "SB"}, 
  {name: "Somalia", code: "SO"}, 
  {name: "South Africa", code: "ZA"}, 
  {name: "South Georgia and the South Sandwich Islands", code: "GS"}, 
  {name: "Spain", code: "ES", continent: "Europe"}, 
  {name: "Sri Lanka", code: "LK"}, 
  {name: "Sudan", code: "SD"}, 
  {name: "Suri", code: "SR"}, 
  {name: "Svalbard and Jan Mayen", code: "SJ"}, 
  {name: "Swaziland", code: "SZ"}, 
  {name: "Sweden", code: "SE", continent: "Europe"}, 
  {name: "Switzerland", code: "CH", continent: "Europe"}, 
  {name: "Syrian Arab Republic", code: "SY"}, 
  {name: "Taiwan, Province of China", code: "TW"}, 
  {name: "Tajikistan", code: "TJ"}, 
  {name: "Tanzania, United Republic of", code: "TZ"}, 
  {name: "Thailand", code: "TH"}, 
  {name: "Timor-Leste", code: "TL"}, 
  {name: "Togo", code: "TG"}, 
  {name: "Tokelau", code: "TK"}, 
  {name: "Tonga", code: "TO"}, 
  {name: "Trinidad and Tobago", code: "TT"}, 
  {name: "Tunisia", code: "TN"}, 
  {name: "Turkey", code: "TR", continent: "Europe"}, 
  {name: "Turkmenistan", code: "TM"}, 
  {name: "Turks and Caicos Islands", code: "TC"}, 
  {name: "Tuvalu", code: "TV"}, 
  {name: "Uganda", code: "UG"}, 
  {name: "Ukraine", code: "UA", continent: "Europe"}, 
  {name: "United Arab Emirates", code: "AE"}, 
  {name: "United Kingdom", code: "GB", continent: "Europe", shipping: "free"}, 
  {name: "United States", code: "US"}, 
  {name: "United States Minor Outlying Islands", code: "UM"}, 
  {name: "Uruguay", code: "UY"}, 
  {name: "Uzbekistan", code: "UZ"}, 
  {name: "Vanuatu", code: "VU"}, 
  {name: "Venezuela", code: "VE"}, 
  {name: "Viet Nam", code: "VN"}, 
  {name: "Virgin Islands, British", code: "VG"}, 
  {name: "Virgin Islands, U.S.", code: "VI"}, 
  {name: "Wallis and Futuna", code: "WF"}, 
  {name: "Western Sahara", code: "EH"}, 
  {name: "Yemen", code: "YE"}, 
  {name: "Zambia", code: "ZM"}, 
  {name: "Zimbabwe", code: "ZW"} 
]);

const US_STATES = fromJS([
  {"name": "Alabama", "code": "AL"},
  {"name": "Alaska", "code": "AK"},
  {"name": "Arizona", "code": "AZ"},
  {"name": "Arkansas", "code": "AR"},
  {"name": "California", "code": "CA"},
  {"name": "Colorado", "code": "CO"},
  {"name": "Connecticut", "code": "CT"},
  {"name": "Delaware", "code": "DE"},
  {"name": "Washington D.C.", "code": "DC"},
  {"name": "Florida", "code": "FL"},
  {"name": "Georgia", "code": "GA"},
  {"name": "Hawaii", "code": "HI"},
  {"name": "Idaho", "code": "ID"},
  {"name": "Illinois", "code": "IL"},
  {"name": "Indiana", "code": "IN"},
  {"name": "Iowa", "code": "IA"},
  {"name": "Kansas", "code": "KS"},
  {"name": "Kentucky", "code": "KY"},
  {"name": "Louisiana", "code": "LA"},
  {"name": "Maine", "code": "ME"},
  {"name": "Maryland", "code": "MD"},
  {"name": "Massachusetts", "code": "MA"},
  {"name": "Michigan", "code": "MI"},
  {"name": "Minnesota", "code": "MN"},
  {"name": "Mississippi", "code": "MS"},
  {"name": "Missouri", "code": "MO"},
  {"name": "Montana", "code": "MT"},
  {"name": "Nebraska", "code": "NE"},
  {"name": "Nevada", "code": "NV"},
  {"name": "New Hampshire", "code": "NH"},
  {"name": "New Jersey", "code": "NJ"},
  {"name": "New Mexico", "code": "NM"},
  {"name": "New York", "code": "NY"},
  {"name": "North Carolina", "code": "NC"},
  {"name": "North Dakota", "code": "ND"},
  {"name": "Ohio", "code": "OH"},
  {"name": "Oklahoma", "code": "OK"},
  {"name": "Oregon", "code": "OR"},
  {"name": "Pennsylvania", "code": "PA"},
  {"name": "Rhode Island", "code": "RI"},
  {"name": "South Carolina", "code": "SC"},
  {"name": "South Dakota", "code": "SD"},
  {"name": "Tennessee", "code": "TN"},
  {"name": "Texas", "code": "TX"},
  {"name": "Utah", "code": "UT"},
  {"name": "Vermont", "code": "VT"},
  {"name": "Virgin Islands", "code": "VI"},
  {"name": "Virginia", "code": "VA"},
  {"name": "Washington", "code": "WA"},
  {"name": "West Virginia", "code": "WV"},
  {"name": "Wisconsin", "code": "WI"},
  {"name": "Wyoming", "code": "WY"}
])

const CA_PROVINCES = fromJS([
 {"name": "Alberta", "code": "AB"},
 {"name": "British Columbia", "code": "BC"},
 {"name": "Manitoba", "code": "MB"},
 {"name": "New Brunswick", "code": "NB"},
 {"name": "Newfoundland and Labrador", "code": "NL"},
 {"name": "Nova Scotia ", "code": "NS"},
 {"name": "Northwest Territories", "code": "NT"},
 {"name": "Nunavut", "code": "NU"},
 {"name": "Ontario", "code": "ON"},
 {"name": "Prince Edward Island", "code": "PE"},
 {"name": "Quebec", "code": "QC"},
 {"name": "Saskatchewan", "code": "SK"},
 {"name": "Yukon", "code": "YT"}
])

export const getCountries = () => {
  return ALL_COUNTRIES;
}

export const getUSStates = () => {
  return US_STATES;
}

export const getCanadaProvinces = () => {
  return CA_PROVINCES;
}

export const getCountryFromCode = (code) => {
  return ALL_COUNTRIES.find(x => x.get("code") === code);
}

export const isUS = (code = "") => {
  return String(code).substr(0,2).toLowerCase() === "us";
}

export const isCanada = (code = "") => {
  return String(code).substr(0,2).toLowerCase() === "ca";
}